<!--
  @Description 数据处理操作窗口(指派、解决、激活)
  @Date 2022-10-25
  @Author liufu
-->
<template>
  <vxe-modal ref="modal" size="mini" v-model="formVisible" title="操作" width="80%" @show="showModal" @hide="hideModal">
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="mini">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="指派人" prop="extra" v-if="operateType !== '解决'">
            <el-select clearable filterable v-model="form.extra" size="small" :placeholder="placeholderConfig.select">
              <el-option
                v-for="i of selectOptions.extra"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="operateType === '指派'">
          <el-form-item label="是否需要回滚" prop="isNeedRollback">
            <el-select clearable v-model="form.isNeedRollback" size="small" :placeholder="placeholderConfig.select">
              <el-option v-for="i of selectOptions.isNeedRollback" :key="i + ''" :label="i" :value="i"></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <!-- <el-form-item label="备注" prop="comment">
        <el-input type="textarea" v-model="form.comment" :placeholder="placeholderConfig.input"></el-input>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item> -->
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px;">
      <!-- 附件框 -->
      <AttachmentCache ref="AttachmentCache" :cacheFileID="id" @uploadFileSuccess="uploadFileSuccess" />
    </div>
    <span style="font-size: 14px">备注</span>
    <YKEditor ref="YKEditor" v-model="form.comment" :editorHeight="editorHeight" />
    <div style="margin-top: 10px;display: flex;justify-content: flex-end;">
      <el-button v-if="operateType === '解决'" @click="uploadAttachment" size="small" type="primary"
        >上传附件</el-button
      >
      <el-button @click="handleCommit" size="small" type="primary">确认</el-button>
    </div>
  </vxe-modal>
</template>
<script>
import YKEditor from '@/components/Editor/YKEditor.vue'
import AttachmentCache from './component/AttachmentCache.vue'

export default {
  name: 'operateModal',
  components: { YKEditor, AttachmentCache },
  props: {
    // 操作类型
    operateType: {
      type: String,
      default: ''
    },
    // 是否需要回滚默认值
    defaultIsNeedRollback: {
      type: String,
      default: '否'
    }
  },
  data() {
    return {
      id: 0, // 主要用于解决时附件上传
      formVisible: false,
      form: {
        extra: '',
        comment: '',
        isNeedRollback: ''
      },
      rules: {
        extra: [{ required: true, message: '请选择 指派人/解决人', trigger: 'change' }],
        isNeedRollback: [{ required: true, message: '请选择 是否需要回滚', trigger: 'change' }],
        comment: []
      },
      // 是否限制当天之后时间不能选择
      isLimitToday: true,
      // 日期选择框配置项
      pickerOptions: null,
      // 下拉框选项
      selectOptions: {
        extra: [],
        isNeedRollback: ['是', '否']
      }
    }
  },
  methods: {
    // 上传附件
    uploadAttachment() {
      this.$refs.AttachmentCache.uploadAttachment()
    },
    // 上传成功
    uploadFileSuccess() {
      this.$emit('sureHandler', this.form)
      this.formVisible = false
    },
    // 获取人员数据
    async getPerson() {
      this.selectOptions.extra = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        const temp = {
          name: item.name,
          value: item.name
        }
        this.selectOptions.extra.push(temp)
      }
    },
    // 初始化单据
    initForm() {
      this.form = {
        extra: '',
        comment: '',
        isNeedRollback: ''
      }
    },
    async showModal() {
      this.form.isNeedRollback = this.defaultIsNeedRollback
      await this.getPerson()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    // 隐藏窗口事件
    hideModal() {
      this.$refs.AttachmentCache.cacheAttachmentList = []
      this.initForm()
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        this.$message.error('校验失败,请检查内容是否合法')
        return
      }
      if (this.operateType === '解决' && this.$refs.AttachmentCache.cacheAttachmentList.length > 0) {
        await this.$refs.AttachmentCache.sureUpload()
      } else {
        this.$emit('sureHandler', this.form)
        this.$nextTick(() => {
          this.formVisible = false
        })
      }
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    }
  },
  computed: {
    editorHeight() {
      const modalTitleHeight = 31
      const modalPadding = 20
      const rowHeight = 78 * 2
      const dividerHeight = 20
      const buttonHeight = 60
      const editorHeaderHeight = 42
      return (
        Number(this.$store.state.clientHeight) * 0.9 -
        modalTitleHeight -
        modalPadding -
        rowHeight -
        dividerHeight -
        buttonHeight -
        editorHeaderHeight -
        84 +
        'px'
      )
    }
  }
}
</script>
<style lang="less" scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>
